"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.logoutEpic = exports.updateAccessTokenByScheduleEpic = exports.refreshAccessTokenEpic = exports.updateTokenEpic = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _index = require("rxjs/operators/index");

var _rxjs = require("rxjs");

var _utils = require("@alycecom/utils");

var _services = require("@alycecom/services");

var _auth = require("../constants/auth.constants");

var _auth2 = require("./auth.actions");

var _auth3 = require("./auth.helpers");

var updateTokenEpic = function updateTokenEpic(action$, state$, _ref) {
  var extensionMessageService = _ref.extensionMessageService,
      _ref$authService = _ref.authService,
      loginUrl = _ref$authService.loginUrl,
      tokenService = _ref$authService.tokenService;
  return action$.pipe((0, _utils.ofType)(_auth2.updateToken), (0, _index.map)(function (action) {
    return action.payload;
  }), (0, _index.distinctUntilChanged)(), (0, _index.tap)(function () {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var token = payload.access_token;

    if (token) {
      tokenService.setToken(token);

      if (extensionMessageService) {
        extensionMessageService.sendMessage(_auth3.COMMAND_UPDATE_COOKIE_TOKEN, token);
      }
    }
  }), (0, _index.map)(function (_ref2) {
    var token = _ref2.access_token;
    return token ? (0, _auth2.refreshTokenSuccess)(token) : (0, _auth2.logoutRequest)(loginUrl);
  }));
};

exports.updateTokenEpic = updateTokenEpic;

var refreshAccessTokenEpic = function refreshAccessTokenEpic(action$, state$, _ref3) {
  var apiService = _ref3.apiService,
      extensionMessageService = _ref3.extensionMessageService,
      _ref3$authService = _ref3.authService,
      tokenService = _ref3$authService.tokenService,
      logoutUrl = _ref3$authService.logoutUrl,
      apiHost = _ref3$authService.apiHost;
  return action$.pipe((0, _utils.ofType)(_auth2.refreshTokenRequest), (0, _index.flatMap)(function () {
    var explicitRefreshTokenSettings = {
      url: "".concat(apiHost).concat(_auth.REFRESH_URL),
      withCredentials: true
    };

    if (extensionMessageService) {
      explicitRefreshTokenSettings.body = {
        refresh_token: tokenService.getRefreshToken()
      };
    }

    var releaserPromise;

    if (!_services.apiReAuthMutex.isLocked()) {
      releaserPromise = _services.apiReAuthMutex.acquire();
    }

    return apiService.refreshToken(null, explicitRefreshTokenSettings).pipe( // eslint-disable-next-line camelcase
    (0, _index.flatMap)(function (response) {
      if (releaserPromise) {
        releaserPromise.then(function (release) {
          release();
        });
      }

      return [(0, _auth2.updateToken)(response)];
    }), (0, _index.catchError)(function () {
      return (0, _rxjs.of)((0, _auth2.logoutRequest)(logoutUrl));
    }));
  }));
};

exports.refreshAccessTokenEpic = refreshAccessTokenEpic;

var updateAccessTokenByScheduleEpic = function updateAccessTokenByScheduleEpic(action$, state$, _ref4) {
  var tokenService = _ref4.authService.tokenService;
  return action$.pipe((0, _utils.ofType)(_auth2.checkAccessTokenBySchedule), (0, _index.withLatestFrom)(state$), (0, _index.filter)(function (_ref5) {
    var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
        state = _ref6[1];

    return state.auth.authenticated;
  }), (0, _index.filter)(function () {
    return tokenService.isExpired();
  }), (0, _index.map)(function () {
    return (0, _auth2.refreshTokenRequest)();
  }));
};

exports.updateAccessTokenByScheduleEpic = updateAccessTokenByScheduleEpic;

var logoutEpic = function logoutEpic(action$, state$, _ref7) {
  var extensionMessageService = _ref7.extensionMessageService,
      tokenService = _ref7.authService.tokenService;
  return action$.pipe((0, _utils.ofType)(_auth2.logoutRequest), (0, _index.withLatestFrom)(state$), (0, _index.map)(function (_ref8) {
    var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
        payload = _ref9[0].payload,
        state = _ref9[1];

    if (payload) {
      return (0, _auth3.addNextParamToUrl)(payload, state.router.location);
    }

    return payload;
  }), (0, _index.tap)(function (url) {
    if (extensionMessageService) {
      extensionMessageService.sendMessage(_auth3.COMMAND_UPDATE_COOKIE_TOKEN, '');
    }

    tokenService.reset(true);
    window.location.href = url || '';
  }), (0, _index.map)(function () {
    return (0, _auth2.logoutSuccess)();
  }));
};

exports.logoutEpic = logoutEpic;
var authEpics = [updateTokenEpic, refreshAccessTokenEpic, updateAccessTokenByScheduleEpic, logoutEpic];
var _default = authEpics;
exports.default = _default;